import {
  Droplets,
  Wind,
  Layers,
  Wrench,
  Home as HomeIcon,
  Hammer,
  Zap,
  HelpCircle,
  type LucideIcon,
} from "lucide-react";
import { GRANTS_MEASURES } from "@/content/grants";
import { SERVICES } from "@/lib/services";

export const RETROFIT_ENQUIRY_OPTION_VALUE = "__retrofit_quotation__";
export const RETROFIT_ENQUIRY_OPTION_LABEL =
  "I Have Had A Retrofit Assessment And Require A Quotation";

export interface IconTile {
  key: string;
  label: string;
  icon: LucideIcon;
}

export const REMEDIAL_WORKS: IconTile[] = [
  { key: "damp-mould", label: "Damp & Mould Treatment", icon: Droplets },
  { key: "ventilation", label: "Ventilation Upgrade", icon: Wind },
  { key: "cavity-extraction", label: "Cavity Wall Extraction", icon: Layers },
  { key: "wall-ties", label: "Remedial Wall Ties", icon: Wrench },
  { key: "loft-prep", label: "Loft Clearance / Prep", icon: HomeIcon },
  { key: "roof-repairs", label: "Roof Repairs", icon: Hammer },
  { key: "electrical", label: "Electrical Works", icon: Zap },
  { key: "plumbing", label: "Plumbing Works", icon: Wrench },
  { key: "other", label: "Other / Not Sure", icon: HelpCircle },
];

export const RETROFIT_MEASURE_TILES: IconTile[] = GRANTS_MEASURES.map((m) => {
  const service = SERVICES.find((s) => s.slug === m.slug);
  return {
    key: m.slug,
    label: service?.shortName ?? m.slug,
    icon: service?.icon ?? HelpCircle,
  };
});
